import React, {useContext} from 'react';
export type SetFieldValue = (field: string, value: any, shouldValidate?: boolean) => void;
export const SetFieldValueContext = React.createContext<SetFieldValue|null>(null);

export function useSetFieldValue(): SetFieldValue {
  const setFieldValue = useContext(SetFieldValueContext);
  if(!setFieldValue) {
    throw new Error('useSetFieldValue must be used within a SetFieldValueContext.Provider');
  }
  return setFieldValue;
}
